import { FC, useRef, useState } from 'react'

import { useTranslation } from 'react-i18next'

import AutoRefundInfoImage from 'features/avia-auto-refund/assets/auto-refund-info.webp'
import { isAutoRefundConfirmationValid } from 'features/avia-auto-refund/lib/auto-refund'

import { InputWithLabel } from 'shared/ui/input-label'

import { AutoRefundDialog } from '../auto-refund-dialog'

interface Props {
  refundAmount: string
  onConfirm: () => Promise<void>
}

export const AutoRefundConfirmation: FC<Props> = ({
  refundAmount,
  onConfirm,
}) => {
  const { t } = useTranslation()

  const loadingRef = useRef(false)
  const [confirmation, setConfirmation] = useState('')
  const [loading, setLoading] = useState(false)

  const handleConfirm = async () => {
    if (loadingRef.current || !isAutoRefundConfirmationValid(confirmation)) {
      return
    }

    loadingRef.current = true
    setLoading(true)

    try {
      await onConfirm()
    } finally {
      loadingRef.current = false
      setLoading(false)
    }
  }

  return (
    <AutoRefundDialog
      image={AutoRefundInfoImage}
      title={t('avia_auto_refund.confirm.title')}
      description={t('avia_auto_refund.confirm.description', {
        amount: refundAmount,
      })}
      button={t('avia_auto_refund.agree')}
      buttonDisabled={!isAutoRefundConfirmationValid(confirmation)}
      buttonLoading={loading}
      content={
        <InputWithLabel
          label={t('avia_auto_refund.confirm.label')}
          value={confirmation}
          onChange={(event) => setConfirmation(event.target.value)}
        />
      }
      onClick={() => void handleConfirm()}
    />
  )
}
